export { default } from './SimpleTable'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Tables/SimpleTable/index.js